import { finish, error } from '../../../modules/audits/actions/open';
import api from '../../../api';

export function request(dispatch, action) {
    /*api.get('/audits/search', void 0, { cache: 1000 }).then(
        (audits) => dispatch(finish(audits)),
        ({ errors }) => dispatch(error(errors))
    );*/
    let audits = require('./audit_example.json'); //(with path)
    dispatch(finish(audits));
}
